import TagsUFs from 'govbr.frontend.policy/components/TagsUFs';

import styles from './Listing.module.less';
import {
  Description,
  EventDateLocation,
  ThumbnailWithoutSize,
  Title,
} from './ListingParts';

export const Event = ({ item, isEditMode }) => {
  const { alt, Subject: tags } = item;

  return (
    <div className={styles.body}>
      <Title item={item} isEditMode={isEditMode} />
      <EventDateLocation
        item={item}
        dateFormat="DD/MM/YYYY"
        timeFormat="HH:mm"
      />
      <ThumbnailWithoutSize
        item={item}
        isEditMode={isEditMode}
        alt={alt}
        className="mt-2 mt-sm-0"
      />
      <Description item={item} hideDatePublished />
      <TagsUFs
        className={'mt-1 mt-sm-0'}
        content={{
          subjects: tags,
        }}
      />
    </div>
  );
};
